<template>
  <div
    class="schedule-calendar-skeleton d-flex flex-column ga-4"
    :style="{ minHeight: `${SCHEDULE_CALENDAR_MIN_HEIGHT_PX}px` }"
  >
    <div class="schedule-calendar-skeleton__days d-flex align-end ga-2">
      <div
        v-for="index in 6"
        :key="`day-skeleton-${index}`"
        class="schedule-calendar-skeleton__day flex-shrink-0"
      />
    </div>
    <div
      class="schedule-calendar-skeleton__slots"
      :class="isMobile
        ? 'schedule-calendar-skeleton__slots--mobile'
        : 'schedule-calendar-skeleton__slots--desktop'"
    >
      <div
        v-for="index in 8"
        :key="`slot-skeleton-${index}`"
        class="schedule-calendar-skeleton__slot"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
/**
 * Скелетон дней и слотов календаря записи, пока грузится расписание.
 */
import useIsMobile from 'src/composables/useIsMobile'
import { SCHEDULE_CALENDAR_MIN_HEIGHT_PX } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuScheduleCalendar/constants/scheduleCalendarMinHeight'

const isMobile = useIsMobile()
</script>

<style lang="scss" scoped>
@import '~www/themes/doctors/common/variables';

.schedule-calendar-skeleton {
  &__days {
    overflow: hidden;
    width: 100%;
  }

  &__day {
    width: 72px;
    height: 58px;
    border-radius: 15px;
    background-color: $ui-kit-bg-gray-40;
  }

  &__slots {
    display: grid;
    gap: 8px;
    width: 100%;

    &--desktop {
      grid-template-columns: repeat(5, max-content);
    }

    &--mobile {
      grid-template-columns: repeat(4, minmax(0, 1fr));
    }
  }

  &__slot {
    width: 70px;
    height: 40px;
    border-radius: 15px;
    background-color: $ui-kit-bg-gray-40;
  }

  &__slots--mobile &__slot {
    width: 100%;
    border-radius: 12px;
  }
}
</style>
